import actions from './actions';

export default {
    actions
};


// WEBPACK FOOTER //
// ./src/store/agent-purchase-list/agent-purchase-list.js